module.exports = __webpack_public_path__ + "img/login-v2.890c1ddc.svg";